module.exports = __webpack_public_path__ + "img/down_arrow.5eb5611f.svg";